module.exports = __webpack_public_path__ + "img/pos_request.7582c379.png";